<template>
  <div class="maizePic">
    <div class="top">
      <h1>Promoter proximal region interaction</h1>
    </div>
    <div class="images" v-if="parentMessage.type === 'gradent'">
      <h2>Trend relationships among bases, sites and gradients</h2>
      <div class="image-section">
        <div v-for="(image, index) in ImagesPPI3D" :key="index" class="images-wrapper">
          <el-image
            :src="image.url"
            :alt="image.name"
            style="width: 500px; height: 500px;"
            fit="scale-down"
            lazy
          ></el-image>
          <div style="font-size: 20px">{{ image.name }}</div>
        </div>
      </div>
    </div>
    <div class="images" v-if="parentMessage.type === 'heatmap'">
      <!-- <h2>row_plots</h2> -->
      <div class="image-section">
        <div
          v-for="(image, index) in ImagesPPIrow_plots"
          class="images-wrapper"
        >
          <el-image
            :key="index"
            :src="image.url"
            :alt="image.name"
            style=" margin: 30px; width: 80%;"
            fit="scale-down"
            lazy
          ></el-image>
          <div style="font-size: 20px">{{ image.name }}</div>
        </div>
      </div>
    </div>
    <div class="images" v-if="parentMessage.type === 'heatmap'">
      <h2>heat_map</h2>
      <div class="image-section">
        <div v-for="(image, index) in ImagesPPIheat_map" class="images-wrapper">
          <el-image
            :key="index"
            :src="image.url"
            :alt="image.name"
            style=" margin: 30px; width: 80%;"
            fit="scale-down"
            lazy
          ></el-image>
          <div style="font-size: 20px">{{ image.name }}</div>
        </div>
      </div>
    </div>
    <div class="top">
      <h1>Promoter distal region interaction</h1>
    </div>
    <div class="images" v-if="parentMessage.type === 'gradent'">
      <h2>Trend relationships among bases, sites and gradients</h2>
      <div class="image-section">
        <div v-for="(image, index) in ImagesPDI3D" class="images-wrapper">
          <el-image
            :key="index"
            :src="image.url"
            :alt="image.name"
            style="width: 500px; height: 500px;"
            fit="scale-down"
            lazy
          ></el-image>
          <div style="font-size: 20px">{{ image.name }}</div>
        </div>
      </div>
    </div>
    <div class="images" v-if="parentMessage.type === 'heatmap'">
      <!-- <h2>row_plots</h2> -->
      <div class="image-section">
        <div
          v-for="(image, index) in ImagesPDIrow_plots"
          class="images-wrapper"
        >
          <el-image
            :key="index"
            :src="image.url"
            :alt="image.name"
            style=" margin: 30px; width: 80%;"
            fit="scale-down"
            lazy
          ></el-image>
          <div style="font-size: 20px">{{ image.name }}</div>
        </div>
      </div>
    </div>
    <div class="images" v-if="parentMessage.type === 'heatmap'">
      <h2>heat_map</h2>
      <div class="image-section">
        <div
          v-for="(image, index) in ImagesPDIheat_map"
          class="images-wrapper"
        >
          <el-image
            :key="index"
            :src="image.url"
            :alt="image.name"
            style="margin: 30px; width: 80%;"
            fit="scale-down"
            lazy
          ></el-image>
          <div style="font-size: 20px">{{ image.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    parentMessage: Object, // 定义接收一个名为 parentMessage 的 prop
  },
  data() {
    return {
      ImagesPPI3D: [],
      ImagesPPIrow_plots: [],
      ImagesPPIheat_map: [],

      ImagesPDI3D: [],
      ImagesPDIrow_plots: [],
      ImagesPDIheat_map: [],
    };
  },
  created() {
    if (this.parentMessage.type === "gradent") {
      this.getImg("maize", "PPI", "3D");
      this.getImg("maize", "PDI", "3D");
    } else if (this.parentMessage.type === "heatmap") {
      this.getImg("maize", "PPI", "row_plots");
      this.getImg("maize", "PPI", "heat_map");

      this.getImg("maize", "PDI", "row_plots");
      this.getImg("maize", "PDI", "heat_map");
    }
  },
  methods: {
    async getImg(project, subtype, type) {
      let res = await this.$API.reqResGrandientImg(project, subtype, type);
      if (subtype === "PPI") {
        if (type === "3D") {
          this.ImagesPPI3D = res.data;
        } else if (type === "row_plots") {
          this.ImagesPPIrow_plots = res.data;
        } else if (type === "heat_map") {
          this.ImagesPPIheat_map = res.data;
        }
      } else if (subtype === "PDI") {
        if (type === "3D") {
          this.ImagesPDI3D = res.data;
        } else if (type === "row_plots") {
          this.ImagesPDIrow_plots = res.data;
        } else if (type === "heat_map") {
          this.ImagesPDIheat_map = res.data;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.maizePic {
  .top {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    height: 70px;
    margin-top: 50px;
    border-radius: 8px;
    h1 {
      font-size: 40px;
      font-weight: bold;
      color: #003164;
    }
  }
  .images {
    text-align: center; // 保持 h2 文本居中

    h2 {
      font-size: 28px;
      font-weight: bold;
      color: #003164;
    }
    .image-section {
      display: flex;
      justify-content: center; // Flex元素整体居中
      flex-wrap: wrap; // 允许图片换行
      .images-wrapper {
        // margin: 0 auto;
        // margin-bottom: 100px;
        el-image {
          width: 500px;
          height: 500px;
          margin: 30px; // 设置图片间距
        }
      }
    }
  }
}
</style>
